import errorImg from "@/assets/icon/nodata.png";
let mixins = {
  data() {
    return {
      screenWidth: document.body.clientWidth,
      currScreenSize: "lg",
      errorImg
    };
  },
  computed: {
    headerClassName() {
      let name = "";
      if (this.currScreenSize === "lg") {
        name = "header-lg";
      }
      if (this.currScreenSize === "md") {
        name = "header-md";
      }
      if (this.currScreenSize === "sm") {
        name = "header-sm";
      }
      if (this.currScreenSize === "xs") {
        name = "header-xs";
      }
      return name;
    },
    menuWarpClassName() {
      let name = "";
      if (this.currScreenSize === "lg") {
        name = "menu-warp-lg";
      }
      if (this.currScreenSize === "md") {
        name = "menu-warp-md";
      }
      if (this.currScreenSize === "sm") {
        name = "menu-warp-sm";
      }
      if (this.currScreenSize === "xs") {
        name = "menu-warp-xs";
      }
      return name;
    },
    homeClassName() {
      let name = "";
      if (this.currScreenSize === "lg") {
        name = "home_warp-lg";
      }
      if (this.currScreenSize === "md") {
        name = "home_warp-md";
      }
      if (this.currScreenSize === "sm") {
        name = "home_warp-sm";
      }
      if (this.currScreenSize === "xs") {
        name = "home_warp-xs";
      }
      return name;
    },
    footerClassName() {
      let name = "";
      if (this.currScreenSize === "lg") {
        name = "footer-lg";
      }
      if (this.currScreenSize === "md") {
        name = "footer-md";
      }
      if (this.currScreenSize === "sm") {
        name = "footer-sm";
      }
      if (this.currScreenSize === "xs") {
        name = "footer-xs";
      }
      return name;
    },
  },
  watch: {
    screenWidth: {
      immediate: true,
      handler(newValue) {
        if (newValue >= 1200) {
          this.currScreenSize = "lg";
        } else if (newValue >= 992 && newValue < 1200) {
          this.currScreenSize = "md";
        } else if (newValue >= 768 && newValue < 992) {
          this.currScreenSize = "sm";
        } else {
          this.currScreenSize = "xs";
        }
      },
    },
  },
  created() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  activated() {
    this.updateScreenWidth();
    window.addEventListener("resize", this.updateScreenWidth);
  },
  deactivated() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      window.screenWidth = document.body.clientWidth;
      this.screenWidth = window.screenWidth;
    },
  },
};

export default mixins;
